import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const SalaryPage: FC = () => {  
    return (
        <Outlet />
    );
}

export default SalaryPage